// vuexを使うために新しく作成した
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// ✖export const store = new Vuex.Store({
// export default store = new Vuex.Store({
//     state: {
//             count:100
//         },
// });

//↓のようにsotreからstateを切り離して定義することも可能 

const state = {
    count :100,
    much_card:[
        {num:1, status:0},
        {num:2, status:0},
        {num:3, status:0},
        {num:4, status:0},
        {num:5, status:0},
        {num:6, status:0},
        {num:7, status:0},
        {num:8, status:0},
        {num:9, status:0},
    ],
    temp_card: 0,
    temp_board:0,
};

const mutations ={
    //increment: state=> state.count++,
    increment(state){
        state.count++
    },
    much_pass(state, n){
        state.much_card[n-1].status++
    },
    put_card_data(state,n){
        state.temp_card = n
    },
    put_board_data(state,n){
        state.temp_board = n
    },
}
const store = new Vuex.Store({
    state,
    mutations,
});

export default store;